export default "__VITE_ASSET__CnPf2$JG__"